module.exports = __webpack_public_path__ + "img/syukyaku-gyoumu-005.d179617e.jpg";